// AUTO-GENERATED SQL Builder (V40 Final) for User
import { 
  SqlField, 
  SqlExp, 
  SqlExpChain, 
  SqlFn, 
  SqlLiteral, 
  SqlSubQuery, 
  SqlApplyColumn, 
  SqlNavHybrid, 
  createNavHybrid 
} from '../utils/sql-core';
import { SqlAst } from '../utils/sql-ast';

export class UserSql {
  private ast = new SqlAst('User', 'user');
  public readonly main: any = {};

  public guid: SqlField;
  public email: SqlField;
  public name: SqlField;
  public passwordHash: SqlField;
  public status: SqlField;
  public hasVerifiedEmail: SqlField;
  public createdByUser: SqlNavHybrid;
  public updatedByUser: SqlNavHybrid;
  public auditLogList: SqlNavHybrid;
  public customerList: SqlNavHybrid;
  public notificationList: SqlNavHybrid;
  public userRoleList: SqlNavHybrid;
  public vendorUserList: SqlNavHybrid;
  public id: SqlField;
  public isDeleted: SqlField;
  public createdBy: SqlField;
  public createdDate: SqlField;
  public updatedBy: SqlField;
  public updatedDate: SqlField;

  constructor() {
    this.guid = new SqlField('user', 'guid', '', 'id', 'user_guid');
    this.email = new SqlField('user', 'email', '', 'id', 'user_email');
    this.name = new SqlField('user', 'name', '', 'id', 'user_name');
    this.passwordHash = new SqlField('user', 'passwordHash', '', 'id', 'user_passwordHash');
    this.status = new SqlField('user', 'status', '', 'id', 'user_status');
    this.hasVerifiedEmail = new SqlField('user', 'hasVerifiedEmail', '', 'id', 'user_hasVerifiedEmail');
    this.createdByUser = createNavHybrid('user', 'user_createdByUser', 'User');
    this.updatedByUser = createNavHybrid('user', 'user_updatedByUser', 'User');
    this.auditLogList = createNavHybrid('user', 'user_auditLogList', 'AuditLog');
    this.customerList = createNavHybrid('user', 'user_customerList', 'Customer');
    this.notificationList = createNavHybrid('user', 'user_notificationList', 'Notification');
    this.userRoleList = createNavHybrid('user', 'user_userRoleList', 'UserRole');
    this.vendorUserList = createNavHybrid('user', 'user_vendorUserList', 'VendorUser');
    this.id = new SqlField('user', 'id', '', 'id', 'user_id');
    this.isDeleted = new SqlField('user', 'isDeleted', '', 'id', 'user_isDeleted');
    this.createdBy = new SqlField('user', 'createdBy', '', 'id', 'user_createdBy');
    this.createdDate = new SqlField('user', 'createdDate', '', 'id', 'user_createdDate');
    this.updatedBy = new SqlField('user', 'updatedBy', '', 'id', 'user_updatedBy');
    this.updatedDate = new SqlField('user', 'updatedDate', '', 'id', 'user_updatedDate');

    for (const k of Object.keys(this)) {
      const v = (this as any)[k];
      if (v instanceof SqlField) this.main[k] = v;
    }
  }

  // SELECT
  select(fn:(x:UserSql)=>any) {
    this.ast.addSelectObject(fn(this));
    return this;
  }

  // WHERE
  where(fn:(x:UserSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  and(fn:(x:UserSql)=>SqlExp | SqlExpChain) {
    this.ast.addWhere(fn(this));
    return this;
  }
  or(fn:(x:UserSql)=>SqlExp | SqlExpChain) {
    this.ast.addOr(fn(this));
    return this;
  }

  // JOIN
  join(fn:(x:UserSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f);
    return this;
  }
  leftJoin(fn:(x:UserSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'LEFT');
    return this;
  }
  rightJoin(fn:(x:UserSql)=>SqlField | SqlNavHybrid) {
    const f = fn(this);
    this.ast.addJoin(f instanceof SqlNavHybrid ? f.asSqlField() : f, 'RIGHT');
    return this;
  }

  // AND JOIN
  andJoin(fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    const last = this.ast.joins[this.ast.joins.length - 1];
    if (!last) throw new Error('andJoin() before join()');

    const left = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(this.ast.alias, prop)
    });
    const right = new Proxy({}, {
      get:(_,prop:string)=> new SqlField(last.alias, prop)
    });

    const exp = (this.ast as any).compileExp(fn(left, right));

    if (typeof last.on === 'string') {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[
          { column:last.on, operator:'', value:null, isTrusted:true, subFilters:[] },
          exp
        ]
      };
    }
    else if (last.on.logic === 'And') {
      last.on.subFilters.push(exp);
    }
    else {
      last.on = {
        logic:'And', isTrusted:false,
        subFilters:[ last.on, exp ]
      };
    }

    return this;
  }

  // CTE
  with(name:string, fn:(c:any)=>any) {
    this.ast.with(name, fn);
    return this;
  }
  withRecursive(name:string, fn:(c:any)=>any) {
    this.ast.withRecursive(name, fn);
    return this;
  }

  // CTE JOIN
  joinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.joinCTE(name, alias, fn);
    return this;
  }
  fullJoinCTE(name:string, alias:string, fn:(l:any,r:any)=>SqlExp | SqlExpChain) {
    this.ast.fullJoinCTE(name, alias, fn);
    return this;
  }

  // SUBQUERY
  subQuery(fn:(b:any)=>any) {
    return new SqlSubQuery(fn);
  }

  // APPLY
  apply(name:string, fn:(b:any)=>any) {
    this.ast.apply(name, fn);
    return this;
  }
  applyColumn(name:string, fn:(b:any)=>SqlField) {
    return this.ast.applyColumn(name, fn);
  }
  crossApply(app:any) {
    this.ast.crossApply(app);
    return this;
  }

  // GROUP BY
  groupBy(fn:(x:UserSql)=>SqlField[]) {
    this.ast.addGroup(fn(this));
    return this;
  }

  // HAVING
  having(fn:(x:UserSql)=>SqlExp | SqlExpChain) {
    this.ast.addHaving(fn(this));
    return this;
  }

  // ORDER
  orderBy(fn:(x:UserSql)=>any[]) {
    this.ast.addOrder(fn(this));
    return this;
  }

  // UNION
  union(fn:(q:any)=>any) {
    this.ast.union(fn);
    return this;
  }
  unionAll(fn:(q:any)=>any) {
    this.ast.unionAll(fn);
    return this;
  }

  limit(n:number) { this.ast.take = n; return this; }
  offset(n:number) { this.ast.skip = n; return this; }

  build() {
    return this.ast.toQueryDescriptor();
  }
}
